import React from 'react';
import bem from 'utils/bem.js';
import { JazzRoom } from '@salutejs/jazz-sdk-web';
import { useVideoSources } from '../utils/hooks/useActiveVideoSource'
import { useVideoElement } from '../utils/hooks/useVideoElement';
import { useRoomContext } from '../contexts/RoomContext';
import { booleanAttribute } from '../utils';
import { useMobile } from 'utils/media.js';
import { LocalVideoPlaceholder } from './VideoPlaceholder';

const { block, el } = bem('conference-video');
export const LocalVideo = ({ participantId }) => {
    const { isMobile } = useMobile();
    const { room } = useRoomContext();
    const { primary } = useVideoSources(participantId);

    const secondaryVideoElement = useVideoElement<HTMLDivElement>({
        participantId,
        room: room as JazzRoom,
        source: primary,
        height: isMobile ? 40 : 120,
        quality: 'medium',
    });

    return (
        <div className={ el('container', 'local') }>
            <div className={ block('local') }
                 ref={ secondaryVideoElement.videoRootRef }
                 data-paused={ booleanAttribute(secondaryVideoElement.isVideoPaused) }
                 data-fit="cover"
            />
            { secondaryVideoElement.isVideoMuted && <LocalVideoPlaceholder /> }
        </div>
    )
}
